export default class SendOTPResponseClass {
    result!: string;
    logId?: string;
    maskedEmail?: string;
    maskedPhoneNumber?: string;
}